import { Box } from '@mui/material'
import UserNameAndAvatar from 'Components/_common/UserNameAndAvatar'
import React from 'react'

import { UserItemContext } from './UserItemContext'

export const UserItem = React.memo(({ user, controls }) => (
  <Box
    key={user.id}
    display="flex"
    alignItems="center"
    justifyContent="space-between"
    width="100%"
  >
    <UserNameAndAvatar
      user={user}
      size="normal"
    />
    <UserItemContext.Provider value={{ user }}>{controls}</UserItemContext.Provider>
  </Box>
))
